// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3SYgD","title":"card_title__KXiix","inActive":"card_inActive__1EikI"};